import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App'; // Esto importará automáticamente App.jsx
import './assets/styles/globals.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);